import { RESOURCES } from "@/lib/constants";

// Mirrors backend planner.build_units: same ids (PL-01…) so assignments survive recalculation.
const META = {
  policia_pie: { prefix: "PL", group: "policia", short: "Agente PL", capacity: 1 },
  patrullas_coche: { prefix: "Z", group: "policia", short: "Patrulla", capacity: 2 },
  patrullas_moto: { prefix: "M", group: "policia", short: "Moto", capacity: 1 },
  auxiliares: { prefix: "AUX", group: "voluntarios", short: "Auxiliar", capacity: 1 },
  proteccion_civil: { prefix: "PC", group: "pc", short: "P. Civil", capacity: 1 },
  organizadores: { prefix: "ORG", group: "voluntarios", short: "Organización", capacity: 1 },
};

export const toMin = (s) => { const m = /^(\d{1,2}):(\d{2})$/.exec(s || ""); return m ? +m[1] * 60 + +m[2] : null; };
export const hm = (m) => { const x = ((Math.round(m) % 1440) + 1440) % 1440; return `${String(Math.floor(x / 60)).padStart(2, "0")}:${String(x % 60).padStart(2, "0")}`; };

export const buildUnits = (shifts = []) => {
  const counters = {};
  const out = [];
  shifts.forEach((sh) => {
    const meta = META[sh.type];
    if (!meta) return;
    const s = toMin(sh.start) ?? 0;
    let e = toMin(sh.end) ?? 1440;
    if (e <= s) e += 1440;
    for (let i = 0; i < (Number(sh.count) || 0); i++) {
      counters[sh.type] = (counters[sh.type] || 0) + 1;
      const id = `${meta.prefix}-${String(counters[sh.type]).padStart(2, "0")}`;
      const tip = (sh.tips?.[i] || "").trim();
      out.push({ id, tip, key: tip || id, type: sh.type, group: meta.group, short: meta.short, capacity: meta.capacity,
        label: RESOURCES.find((r) => r.key === sh.type)?.label || meta.short, shiftFrom: s, shiftTo: e, shiftHm: `${sh.start}–${sh.end}`, shiftLabel: sh.label || "" });
    }
  });
  return out;
};

// Same matching as backend assign.owner: TIP first, then the unit id.
export const ownerOf = (a, units) => units.find((u) => u.tip && u.tip === a.unit_key) || units.find((u) => u.id === a.unit_id || u.id === a.unit_key);
export const isMine = (a, unit, units) => ownerOf(a, units) === unit;

// Same timeline rules as backend assign.py: a post lasts until the next one or the end of the shift.
export const unitPosts = (unit, assignments, anchor, units = [unit]) => {
  const mine = assignments.filter((a) => isMine(a, unit, units) && toMin(a.time) != null && a.loc?.length === 2)
    .map((a) => { const s = toMin(a.time); return { ...a, start: s < anchor ? s + 1440 : s }; })
    .sort((a, b) => a.start - b.start);
  return mine.map((a, i) => ({ ...a, end: i + 1 < mine.length ? mine[i + 1].start : Math.max(unit.shiftTo, a.start + 30) }));
};

export const staffPointsFrom = (units, assignments, anchor) => {
  const pts = [];
  units.forEach((u) => unitPosts(u, assignments, anchor, units).forEach((a) => {
    let p = pts.find((x) => Math.hypot((x.loc[0] - a.loc[0]) * 110540, (x.loc[1] - a.loc[1]) * 82000) <= 20);
    if (!p) { p = { key: a.id, loc: a.loc, groups: {}, units: {}, tasks: [], task_ids: [], slots: [] }; pts.push(p); }
    if (!(p.units[u.group] || []).includes(u.key)) {
      p.groups[u.group] = (p.groups[u.group] || 0) + u.capacity;
      (p.units[u.group] = p.units[u.group] || []).push(u.key);
    }
    p.slots.push({ g: u.group, uid: u.key, persons: u.capacity, start: a.start, end: a.end });
    p.task_ids.push(a.id);
    const n = a.place || "Puesto";
    if (!p.tasks.includes(n)) p.tasks.push(n);
  }));
  return pts;
};
